export const SMS_SENDER_INFO = {
  Yoigo: 'YOIGO',
}
